import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

const httpOptions = {
   headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export default class Api {
   //private BASEURL = 'http://167.99.93.154:8080/sonavie/';
   private BASEURL = '/sonavie/';
   constructor(private http: HttpClient) { }

   get(endPoint): Observable<any>{
      return this.http.get(`${this.BASEURL}${endPoint}`, httpOptions)
   }

   post(endPoint, body): Observable<any>{
      return this.http.post(`${this.BASEURL}${endPoint}`, body, httpOptions);
   }
   request(req){
      return this.http.request(req)
   }
}


// WEBPACK FOOTER //
// ./src/app/common/services/api.service.ts